import angular from 'angular';

import Component from './calendar-all-day.component';

const Module = angular
    .module('control-room.commons.data.components.calendar.components.calendar-all-day', [])
    .component('crCalendarAllDay', Component);

export default Module;
